class Point {
  constructor (x = 0, y = 0) {
    this.x = x
    this.y = y
  }
  reset () {
    this.x = 0
    this.y = 0
  }
}

class DragCursor {
  constructor (controller, dragSensitivity, dragThesholdX, dragThesholdY) {
    this.controller = controller
    this.dragSensitivity = dragSensitivity
    this.dragTheshold = new Point(dragThesholdX, dragThesholdY)
    this.dragThesholdActivated = false
    this.isDragging = false
    this.hasDragged = false
    this.startPt = new Point()
    this.offset = new Point()
    this.offsetInit = new Point()
  }
  onDragStart (e) {
    if (this.isDragging) return
    this.isDragging = true
    this.startPt.x = e.touches[0].screenX
    this.startPt.y = e.touches[0].screenY
  }
  onDragMove (e, xOverride) {
    if (!this.isDragging) return
    this.hasDragged = true
    this.updateOffset(e)
    if (xOverride) {
      this.dragThesholdActivated = 'x'
    }
    if (!this.dragThesholdActivated) {
      if (Math.abs(this.offset.x) > this.dragTheshold.x) {
        this.dragThesholdActivated = 'x'
      } else if (Math.abs(this.offset.y) > this.dragTheshold.y) {
        this.dragThesholdActivated = 'y'
      }
    }
    if (this.dragThesholdActivated === 'x') {
      this.dragOffset(this.offset.x + this.offsetInit.x)
      try {
        e.preventDefault()
      } catch (e) {
        console.log(e)
      }
    }
  }
  onDragEnd (e) {
    if (!this.isDragging) return

    this.updateOffset(e)
    if (this.dragThesholdActivated === 'x') {
      this.dragOffset(this.offset.x + this.offsetInit.x, true)
    }

    this.isDragging = false
    this.hasDragged = false
    this.startPt.reset()
    this.offset.reset()
    this.offsetInit.reset()
    this.dragThesholdActivated = false
  }
  dragOffset (offsetX, complete) {
    let step = Math.round(offsetX / this.dragSensitivity)
    this.controller.setOffset(offsetX)
    if (complete) {
      this.controller.setSelectedIndex(this.controller.highlightIndex)
    } else {
      this.controller.setHighlightIndex(this.controller.selectedIndex + step)
    }
  }
  updateOffset (e) {
    this.offset.x = e.changedTouches[0].screenX - this.startPt.x
    this.offset.y = e.changedTouches[0].screenY - this.startPt.y
  }
}

export default DragCursor
